import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { Dialog, DialogContent, DialogActions } from '../../../common/components';
import messages from '../../messages';

const S = {
  Dialog: styled(Dialog)`
    .paper {
      position: relative;
      width: 480px;
      padding: 32px 40px 24px;
    }
  `,
  DialogContent: styled(DialogContent)`
    margin-bottom: 40px;
  `,
  DialogActions: styled(DialogActions)`
    display: flex;
  `,
  CancelButton: styled(Button)`
    min-width: 80px;
    min-height: 40px;
    border-color: ${({ theme }) => theme.palette.grey[400]};
    font-weight: 500;
    line-height: 1.54;
  `,
  DeleteButton: styled(Button)`
    min-width: 80px;
    min-height: 40px;
    color: ${({ theme }) => theme.palette.error.main};
    border-color: ${({ theme }) => theme.palette.error.main};
    font-weight: 500;
    line-height: 1.54;
    :focus, :hover {
      background-color: ${({ theme }) => theme.palette.hexToRgb(theme.palette.error.main, 0.08)};
    }
  `,
};

const DeleteConfirmationDialog = ({
  counts, open, onClose, onDelete,
}) => {
  const handleClick = useCallback(() => {
    onClose();

    onDelete();
  }, [onClose, onDelete]);

  return (
    <S.Dialog open={open} onClose={onClose}>
      <S.DialogContent>
        <FormattedMessage
          {...messages[counts.total && (counts.checked === counts.total)
            ? 'deleteConfirmationDialogTotal'
            : 'deleteConfirmationDialogChecked']}
          values={{ br: <br />, count: counts.checked }}
        />
      </S.DialogContent>
      <S.DialogActions>
        <S.CancelButton type="button" variant="outlined" onClick={onClose}>
          <FormattedMessage {...messages.deleteConfirmationDialogCancelButton} />
        </S.CancelButton>
        <S.DeleteButton
          type="button"
          variant="outlined"
          onClick={handleClick}
        >
          <FormattedMessage
            {...messages[counts.total && (counts.checked === counts.total)
              ? 'deleteConfirmationDialogDeleteButtonAll'
              : 'deleteConfirmationDialogDeleteButton']}
          />
        </S.DeleteButton>
      </S.DialogActions>
    </S.Dialog>
  );
};

DeleteConfirmationDialog.propTypes = {
  counts: PropTypes.shape({
    checked: PropTypes.number,
    total: PropTypes.number,
  }).isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default DeleteConfirmationDialog;
